var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('img',{staticClass:"high-light",attrs:{"src":require("../../public//images/high-light.png"),"alt":""}}),_c('img',{staticClass:"circle",attrs:{"src":require("../../public/images/m-circle.png"),"alt":""}}),_c('div',{ref:"mapChartRef",staticClass:"map-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }